import { useState, type ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

interface QueryProviderProps {
  children: ReactNode;
}

/**
 * Single TanStack Query client for the admin app.
 *
 * Defaults are operations-friendly: stale-after-30s (so a list view doesn't
 * spam the API on every keystroke filter change) and no refetch-on-focus
 * (admin sits in the background tab a lot — refetch storms are noisy).
 */
export function QueryProvider({ children }: QueryProviderProps) {
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            refetchOnWindowFocus: false,
            retry: 1,
          },
        },
      }),
  );

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
